module.exports = "/shifts/components/dayModeEventsRowComponent-2030c6.html";